export default __webpack_public_path__ + "static/boots1.inspirations-466fa5fd7dd4c6efd3bc5eb1fa5ae6f3.jpg";